module.exports = __webpack_public_path__ + "static/media/screen-en.552989ca.png";